import { createSlice } from '@reduxjs/toolkit';

import User from '../model/User';

import type { PayloadAction } from '@reduxjs/toolkit';
import type { RentalManagerAuthCheckUserInfoWebApiDto } from '@zg-rentals/ts-rental-manager-api-beta-client';

const initialState = User();

const userSlice = createSlice({
  name: 'user',
  initialState,

  reducers: {
    updateEmailVerified: (state, action: PayloadAction<boolean>) => {
      state.isEmailVerified = action.payload;
    },

    updateUserCookies: (
      state,
      {
        payload: { apiResponseServerSideRequestCookies, originalServerSideRequestCookies, encodedGuidZuid },
      }: PayloadAction<
        Partial<
          Pick<
            typeof initialState,
            'apiResponseServerSideRequestCookies' | 'originalServerSideRequestCookies' | 'encodedGuidZuid'
          >
        >
      >,
    ) => {
      if (apiResponseServerSideRequestCookies !== undefined) {
        state.apiResponseServerSideRequestCookies = apiResponseServerSideRequestCookies;
      }

      if (originalServerSideRequestCookies !== undefined) {
        state.originalServerSideRequestCookies = originalServerSideRequestCookies;
      }

      if (encodedGuidZuid !== undefined) {
        state.encodedGuidZuid = encodedGuidZuid;
      }
    },

    setUser: (_, action: PayloadAction<RentalManagerAuthCheckUserInfoWebApiDto>) => User(action.payload),
  },
});

export const { updateEmailVerified, updateUserCookies, setUser } = userSlice.actions;

export default userSlice.reducer;
